import * as errors from "../errors.js";

/*
    The ASC keyword takes the first char of a string and maps it to the numeric index of the Commodore ASCII-table. This value can be converted back to the character by using the CHR$ function.
    Evaluation of an empty string ("") results in the BASIC-error ?ILLEGAL QUANTITY ERROR. If the operand doesn't evaluate to a string the BASIC error ?TYPE MISMATCH ERROR appears. 
    If no operand is provided the error message ?SYNTAX ERROR shows up. 
*/
export const asc = async (args) => {
    // Example of valid args:
    // ASC("A") (Screen: 65)
    // ASC("AB") (Screen: 65)
    // ASC("") (Screen: ?ILLEGAL QUANTITY ERROR)
    // ASC(123) (Screen: ?TYPE MISMATCH ERROR)
    // ASC() (Screen: ?SYNTAX ERROR)

    // If no args are given, throw a syntax error.
    if (args.length === 0) {
        throw new errors.IllegalQuantityError();
    }

    // Check if the args is a string.
    if (typeof args !== "string") {
        throw new errors.TypeMismatchError();
    }

    const result = args.charCodeAt(0);

    // Check if the result is within the range of a Commodore ASCII value.
    if (result < 0 || result > 255) {
        throw new errors.OverflowError();
    }

    return result;
}